// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__HUqHd","panel":"Layout_panel__cb0ET","frame":"Layout_frame__fHpZI"};